import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
// import { MusicPlayerPageModule } from '../pages/music-player/music-player.module';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('../pages/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'album/:albumId',
    loadChildren: () =>
      import('../pages/album/album.module').then((m) => m.AlbumPageModule),
  },
  {
    path: 'artist/:artistId',
    loadChildren: () =>
      import('../pages/artist/artist.module').then((m) => m.ArtistPageModule),
  },
  {
    path: 'browse',
    loadChildren: () =>
      import('../pages/browse/browse.module').then((m) => m.BrowsePageModule),
  },
  {
    path: 'change-name/:arg',
    loadChildren: () =>
      import('../pages/change-name/change-name.module').then(
        (m) => m.ChangeNamePageModule
      ),
  },
  {
    path: 'change-name/:arg/:userName',
    loadChildren: () =>
      import('../pages/change-name/change-name.module').then(
        (m) => m.ChangeNamePageModule
      ),
  },
  {
    path: 'favorites/:favoriteType',
    loadChildren: () =>
      import('../pages/favorites/favorites.module').then(
        (m) => m.FavoritesPageModule
      ),
  },
  {
    path: 'genre',
    loadChildren: () =>
      import('../pages/genre/genre.module').then((m) => m.GenrePageModule),
  },
  // {
  //   path: 'home',
  //   loadChildren: () => import('../pages/home/home.module').then(m => m.HomePageModule)
  // },
  {
    path: 'library',
    loadChildren: () =>
      import('../pages/library/library.module').then(
        (m) => m.LibraryPageModule
      ),
  },
  {
    path: 'login-details',
    loadChildren: () =>
      import('../pages/login-details/login-details.module').then(
        (m) => m.LoginDetailsPageModule
      ),
  },
  {
    path: 'music-player',
    loadChildren: () => import('../pages/music-player/music-player.module').then(m => m.MusicPlayerPageModule)
  },
  {
    path: 'playlist/:playlist',
    loadChildren: () =>
      import('../pages/playlist/playlist.module').then(
        (m) => m.PlaylistPageModule
      ),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('../pages/profile/profile.module').then(
        (m) => m.ProfilePageModule
      ),
  },
  // {
  //   path: 'search',
  //   loadChildren: () => import('../pages/search/search.module').then(m => m.SearchPageModule)
  // },
  {
    path: 'settings',
    loadChildren: () =>
      import('../pages/settings/settings.module').then(
        (m) => m.SettingsPageModule
      ),
  },
  {
    path: 'tabs',
    loadChildren: () =>
      import('../pages/tabs/tabs.module').then((m) => m.TabsPageModule),
  },
  {
    path: 'termsprivacy/:arg',
    loadChildren: () =>
      import('../pages/terms-privacy/terms-privacy.module').then(
        (m) => m.TermsPrivacyPageModule
      ),
  },
  {
    path: 'payment',
    loadChildren: () => import('../pages/payment/payment.module').then(m => m.PaymentPageModule)
  },
    {
    path: 'categories-detail',
    loadChildren: () => import('../pages/categories-detail/categories-detail.module').then( m => m.CategoriesDetailPageModule)
  },
  // {
  //   path: 'terms',
  //   loadChildren: () => import('../pages/terms-privacy/terms-privacy.module').then(m => m.TermsPrivacyPageModule)
  // },
  // {
  //   path: 'privacy',
  //   loadChildren: () => import('../pages/terms-privacy/terms-privacy.module').then(m => m.TermsPrivacyPageModule)
  // },
  // {
  //   path: 'register',
  //   loadChildren: () => import('../pages/login-details/login-detaila.module').then(m => m.RegisterPageModule)
  // },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'categories',
    loadChildren: () => import('../pages/categories/categories.module').then( m => m.CategoriesPageModule)
  },


  // {
  //   path: 'privacy',
  //   loadChildren: () => import('../pages/privacy/privacy.module').then(m => m.PrivacyPageModule)
  // },
  // {
  //   path: 'terms',
  //   loadChildren: () => import('../pages/terms-/terms.module').then(m => m.TermsPageModule)
  // },
  // {
  //   path: 'search',
  //   loadChildren: () => import('../pages/search/search.module').then(m => m.SearchPageModule)
  // },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
